import React, { FunctionComponent, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { Col, CustomInput, FormGroup, Label } from "reactstrap";
import Row from "components/atoms/Row";
import Button from "components/atoms/Button";
import Icon from "components/atoms/Icon";
import { StepProps } from "interfaces/formstepper/FormStepperInterfaces";
import { useIntl } from "react-intl";
import Popover from "../atoms/Popover";
import { ANSWER } from "constants/common/CommonConstants";

const validationSchema = Yup.object({
  youngCouple: Yup.string().required(" ")
});

export const FormCouple: FunctionComponent<StepProps> = ({ formData, setFormData, nextStep, prevStep }) => {
  const intl = useIntl();
  const handlePrevClick = () => prevStep();
  const [popoverInfoOpen, setPopoverInfo] = useState(false)
  const togglePopoverInfo = () => setPopoverInfo((state: boolean) => !state);
  return (
    <>
      <Formik
        initialValues={formData}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          setFormData(values)
          nextStep();
        }}
      >
        {({
          touched,
          errors,
          values,
          setFieldValue
        }) => (
          <Form>
            <FormGroup className="text-center">
              <Label>{intl.formatMessage({ id: "form_question_youngCouple" })}</Label>
              <Button id="popInfo" type="button" outline size="xs" color="dark" icon pill>i</Button>
              <Row grid gutters="sm" justifyContent="center">
                <Col xs="6" md="4">
                  <CustomInput
                    invalid={touched.youngCouple && !!errors.youngCouple}
                    type="radio"
                    name="youngCouple"
                    id={ANSWER.YES}
                    label={intl.formatMessage({ id: "general_form_answer_yes" })}
                    value={ANSWER.YES}
                    checked={values.youngCouple === ANSWER.YES}
                    onChange={() => setFieldValue("youngCouple", ANSWER.YES)}
                  />
                </Col>
                <Col xs="6" md="4">
                  <CustomInput
                    invalid={touched.youngCouple && !!errors.youngCouple}
                    type="radio"
                    name="youngCouple"
                    id={ANSWER.NO}
                    label={intl.formatMessage({ id: "general_form_answer_no" })}
                    value={ANSWER.NO}
                    checked={values.youngCouple === ANSWER.NO}
                    onChange={() => setFieldValue("youngCouple", ANSWER.NO)}
                  />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup className="FormFooter d-flex justify-content-center flex-column flex-sm-row">
              <Button
                type="button"
                color="link"
                onClick={handlePrevClick}
                className="align-self-center"
              >
                <Icon name="ChevronLeft" />
                <span className="Text">{intl.formatMessage({ id: "form_stepper_button_prev" })}</span>
              </Button>
              <Button
                type="submit"
                color="primary"
              >
                {intl.formatMessage({ id: "form_stepper_button_next" })}
              </Button>
            </FormGroup>
          </Form>
        )}
      </Formik>
      <Popover isOpen={popoverInfoOpen} toggle={togglePopoverInfo}>
        {intl.formatMessage({ id: "form_info_youngCouple" })}
      </Popover>
    </>
  );
};